import { BaseItem } from './common';

export enum AgesServed {
  AllAges = 'Serving all ages',
  EighteenAndUp = '18+',
  TenAndUp = '10+',
  TwentyOneAndUnder = '0-21',
}

type FullPreference = {
  displayInDirectory: boolean;
  acceptsNewPatients: boolean;
  offersOnlineScheduling: boolean;
  offersVirtualVisits: boolean;
  schedulingLink: string;
  videoUrl: string;
  reputationId: string;
  acceptedPayorWithPlanTypes: string[];
  slug: string;
  providerDirectoryUrl: string;
  agesServed: AgesServed[];
  locations: string[];
  ableToSchedule: boolean;
};

export type Preference = Partial<FullPreference>;

export interface BaseProviderOrganizationPreference {
  providerUserId: string;
  organizationId: string;
  preference: Preference;
}

export interface ProviderOrganizationPreference
  extends BaseItem,
    BaseProviderOrganizationPreference {}

export interface ProviderOrganizationPreferenceWithOrgName
  extends BaseProviderOrganizationPreference {
  organizationName: string;
}
